import { useState } from 'react';
import { Button, Col, Form } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { ThumbnailItem } from 'common/components';
import { ProductEditBrandModal } from 'pages/product-full-view/components';

import './RequiredBrand.less';

export const RequiredBrand = ({
  memberIdBrand,
  formInstance: formInstanceProp,
}) => {
  const [visibleBrand, setVisibleBrand] = useState(false);
  const [brandId, setBrandId] = useState(null);
  const [brandThumb, setBrandThumb] = useState(null);

  const [selectedBrandName, setSelectedBrandName] = useState();

  const _formInstance = Form.useFormInstance();

  const formInstance = formInstanceProp ?? _formInstance;

  const handleResetBrand = () => {
    setBrandId(null);
    setBrandThumb(null);

    formInstance.setFieldsValue({ brandId: null });
    formInstance.validateFields(['brandId']).catch(() => {});
  };

  return (
    <Col flex='auto'>
      <Form.Item name='brandId'>
        {brandId && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <ThumbnailItem
                hideCheckbox
                style={{ marginLeft: 0 }}
                imageThumbnail={brandThumb}
                labelThumbnail={selectedBrandName}
              />
              <div className='required-brand-wrapper'>
                <span className='required-brand-close'>
                  <CloseCircleOutlined
                    style={{
                      fontSize: 20,
                      color: '#ff4d4f',
                      cursor: 'pointer',
                      backgroundColor: '#fff',
                      borderRadius: '50%',
                      display: 'block',
                      pointerEvents: 'auto',
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleResetBrand();
                    }}
                  />
                </span>
              </div>
            </div>
          </div>
        )}
        <Button
          onClick={() => setVisibleBrand(true)}
          className='required-product__brand-error'
        >
          {brandId ? 'Update Brand' : 'Link to Brand'}
        </Button>
      </Form.Item>

      {visibleBrand && (
        <ProductEditBrandModal
          visible={visibleBrand}
          setVisibleEditBrand={setVisibleBrand}
          isAddProduct={true}
          setBrandId={(id) => {
            setBrandId(id);
            formInstance.setFieldsValue({ brandId: id });
            formInstance.validateFields(['brandId']).catch(() => {});

            if (_formInstance) {
              _formInstance.setFieldsValue({ brandId: id });
              _formInstance.validateFields(['brandId']).catch(() => {});
            }
          }}
          onSelectBrand={(brand) => {
            if (brand?.brandName) setSelectedBrandName(brand?.brandName);
          }}
          setBrandThumb={setBrandThumb}
          memberIdFromBrand={memberIdBrand}
        />
      )}
    </Col>
  );
};
